import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.title',
		defaultMessage: 'Build an advanced prompt',
		description: 'Describes an option to use Atlassian Intelligence to show a more advanced prompt',
	},
	description: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.description',
		defaultMessage: 'Specify task, instructions and rules',
		description: 'Description for the the Atlassian Intelligence "Build an advanced prompt".',
	},
	promptLabel: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptLabel',
		defaultMessage: 'Build an advanced prompt',
		description: 'Label text in the prompt input.',
	},
	taskLabel: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.task.label',
		defaultMessage: 'Task',
		description: 'Label for the Task input in the prompt builder.',
	},
	taskPlaceholder: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.task.placeholder',
		defaultMessage:
			'Your task is to create onboarding documentation for new employees joining the team so they can find what they need in their first week.',
		description: 'Placeholder for the Task input in the prompt builder.',
	},
	taskHelperMessage: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.task.helperMessage',
		defaultMessage: 'Describe the task that needs completing.',
		description: 'Helper message for the Task input in the prompt builder.',
	},
	taskRequired: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.task.error.required',
		defaultMessage: 'Please provide task',
		description: 'Error message for the Task input in the prompt builder.',
	},
	instructionsLabel: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.instructions.label',
		defaultMessage: 'Instructions',
		description: 'Label for the Instructions input in the prompt builder.',
	},
	instructionsPlaceholder: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.instructions.placeholder',
		defaultMessage:
			'1. Start with a brief overview of our company goals.{br}' +
			'2. Give new employees context on how their work and role relates to the company goals.{br}' +
			'3. Create a list of key team members to meet in their first week.{br}' +
			'4. Create a page outline for their 30, 60, and 90 day plan, including any mandatory training.{br}' +
			'5. Create a list of relevant links for company processes and resources.',
		description: 'Placeholder for the Instructions input in the prompt builder.',
	},
	instructionsHelperMessage: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.instructions.helperMessage',
		defaultMessage: 'Provide instructions for completing the task.',
		description: 'Helper message for the Instructions input in the prompt builder.',
	},
	rulesLabel: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.rules.label',
		defaultMessage: 'Rules',
		description: 'Label for the Rules input in the prompt builder.',
	},
	rulesPlaceholder: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.rules.placeholder',
		defaultMessage:
			'- The documentation should mainly refer to Our Team and Company Confluence Space.{br}' +
			'- Provide clear answers with short sentences and plain language.{br}' +
			'- Create a table of contents so the page is easy to navigate.{br}' +
			'- Ensure the page follows the company style guidelines. ',
		description: 'Placeholder for the Rules input in the prompt builder.',
	},
	rulesHelperMessage: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.rules.helperMessage',
		defaultMessage: 'Outline any rules that must be followed.',
		description: 'Helper message for the Rules input in the prompt builder.',
	},
	toneLabel: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.tone.label',
		defaultMessage: 'Tone',
		description: 'Label for the Tone input in the prompt builder.',
	},
	toneProfessional: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.tone.option.professional',
		defaultMessage: 'Professional',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneEmpathetic: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.tone.option.empathetic',
		defaultMessage: 'Empathetic',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneCasual: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.tone.option.casual',
		defaultMessage: 'Casual',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneNeutral: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.tone.option.neutral',
		defaultMessage: 'Neutral',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneEducational: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.tone.option.educational',
		defaultMessage: 'Educational',
		description: 'Option for the Tone input in the prompt builder.',
	},
	creativityLabel: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.creativity.label',
		defaultMessage: 'Creativity',
		description: 'Label for the Creativity input in the prompt builder.',
	},
	creativityLow: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.creativity.option.low',
		defaultMessage: 'Low',
		description: 'Option for the Creativity input in the prompt builder.',
	},
	creativityMedium: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.creativity.option.medium',
		defaultMessage: 'Medium',
		description: 'Option for the Creativity input in the prompt builder.',
	},
	creativityHigh: {
		id: 'fabric.editor.ai.config.item.advancedPrompt.promptBuilder.creativity.option.high',
		defaultMessage: 'High',
		description: 'Option for the Creativity input in the prompt builder.',
	},
});
